import { CustomSwitch } from "../Toolbar/utils";
import { useState } from "react";

export default function ActiveSwitch({ active }) {
  const [isActive, setIsActive] = useState(active);
  // const handleChange = () => {
  //   setIsActive(!isActive);
  // };
  return (
    <CustomSwitch
      id="active-switch"
      checked={isActive}
      // onChange={handleChange}
      inputProps={{ "aria-label": "controlled" }}
      color="secondary"
    />
  );
}
